/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    span: "span"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "If you want to print the value of an environment variable, you can use the ", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<code class=\"language-text\">$env:variable_name</code>"
    }
  }), " syntax."), "\n", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<div class=\"gatsby-highlight\" data-language=\"powershell\"><pre class=\"language-powershell\"><code class=\"language-powershell\"><span class=\"token variable\">$env</span>:MY_VARIABLE</code></pre></div>"
    }
  }), "\n", React.createElement(_components.p, null, "Replace ", React.createElement(_components.span, {
    dangerouslySetInnerHTML: {
      __html: "<code class=\"language-text\">MY_VARIABLE</code>"
    }
  }), " with the name of the environment variable you want to print."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
